import { request } from '@/api/request';

// Fetches flags with user/org overrides; to be called in authenticated contexts.
const fetchUserFlags = () => request('GET', '/flags');

// Fetches flags without user/org overrides; useful for calling in unauthenticated contexts.
const fetchPublicFlags = () => request('GET', '/flags/public');

const setOverrideForSelf = (flag: string, enabled: boolean) =>
  request('PUT', `/flags/overrides/${flag}`, { enabled });

const api = {
  fetchUserFlags,
  fetchPublicFlags,
  setOverrideForSelf,
};
export default api;

export const replaceAPI = (newApi: Record<string, () => any>) => {
  Object.keys(newApi).forEach((i) => {
    (api as any)[i] = newApi[i];
  });
};
